import { addStyles } from 'ethcss'
import { mediaCSS } from 'blocks.app/config'
import grid from 'blocks.simple/grid/grid.jcss'
import { IStyles } from '../../../theme'

const deviceSettingsProxyStyles: IStyles = {
    fieldsWrapper: {
        ...grid.row,
        ...grid.w50,
        justifyContent: 'space-between',
        [mediaCSS.tab]: {
            ...grid.w45,
        },
        [mediaCSS.tabMini]: {
            ...grid.w100,
        },
    },
    inputWrapper: {
        width: '48%',
    },
    caption: {
        marginBottom: 14,
    },
}

addStyles(deviceSettingsProxyStyles)
export default deviceSettingsProxyStyles
